import Grid from '@mui/material/Grid2';
import { Typography, Stack } from '@mui/material';
import { TypographyBold } from '../style/typography';
import { AvailableButton, UnAvailableButton } from "../style/button";

export const CalloutSection = ({
  titleIcon: TitleIcon,
  title,
  message,
  availableIconComponent: AvailableIconComponent,
  cancelIconComponent: CancelIconComponent,
  onClickAvailable,
  onClickUnAvailable,
  possibleButtonName,
  impossibleButtonName
}) => {
  return (
    <Grid size={{ xs: 12 }}>
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 9 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <TitleIcon sx={{ fontSize: '2.5rem', color: '#0A7CB7' }} />
                    <TypographyBold>{title}</TypographyBold>
                </Stack>
                <Typography sx={{ mt: 2 }}>
                  {message}
                </Typography>
            </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12, md: 6 }}>
                <AvailableButton
                    startIcon={AvailableIconComponent}
                    onClick={onClickAvailable}
                >
                    {possibleButtonName}
                </AvailableButton>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
                <UnAvailableButton
                    startIcon={CancelIconComponent}
                    onClick={onClickUnAvailable}
                >
                    {impossibleButtonName}
                </UnAvailableButton>
            </Grid>
        </Grid>
    </Grid>
  )
}